<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Seguimiento
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Seguimiento
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6 sm3 style='margin-top:10px;margin-bottom:4px;')
                  v-select(outline
                    :items="opcion1"
                    v-model="filtroVen"
                    style='padding-left: 15px;'
                    label="Vendedor:")
                v-flex(xs6 sm3 style='margin-top:10px;margin-bottom:4px;')
                  v-select(outline
                    :items="opcion2"
                    v-model="filtroPed"
                    style='padding-left: 15px;'
                    label="Información a mostrar:")
                v-flex(xs6 sm3 style='margin-top:10px;margin-bottom:4px;' v-if='filtroPed === "2"')
                  v-menu(ref='menu1' v-model='menu1' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                    template(v-slot:activator='{ on, attrs }')
                      v-text-field(v-model='dateFormatted' label='Fecha' hint='MM/DD/YYYY format'  style='padding-left: 15px;' outline persistent-hint='' append-icon='calendar_today' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
                    v-date-picker(v-model='date' no-title='' @input='menu1 = false' dark='')
                v-flex(xs6 sm3 style='display: flex;padding-left: 20px;align-items: center;')
                  v-btn(icon style="background:#ff6500;border-radius:10px;" @click='busqueda()').elevation-4
                    v-icon(color='white') search
        
        .map-container(style="height: 500px; width: 100%; position: relative;")
          l-map(
            ref="map"
            :zoom="zooom"
            :center="[centrarmapa.lat, centrarmapa.lng]"
            style="height: 100%; width: 100%;"
          )
            l-tile-layer(
              :url="url"
            )
            l-marker(
              v-for="(item, index) in marcadores"
              :key="index"
              :lat-lng="[item.coordenadas.lat, item.coordenadas.lng]"
              :icon="getIcon(item)"
              @click="openInfoWindowTemplate(item)"
            )
              l-popup(:options="{ closeButton: true, maxWidth: 300 }")
                div(style='display:flex;flex-direction:column;')
                  span(v-if='item.doc_num') 
                    b Pedido: 
                    | {{item.doc_num}}
                  div 
                    b Vendedor: 
                    | {{item.vendedor}}
                  span(v-if='item.cliente') 
                    b Cliente: 
                    | {{item.cliente}}
                  span(v-if='!item.doc_num') 
                    b Última conexión: 
                    | {{item.fecha | moment('DD-MM-YYYY H:mm A')}}
                  span(v-else) 
                    b Fecha: 
                    | {{item.fecha | moment('DD-MM-YYYY H:mm A')}}
                  p
                  a(v-if='item.doc_num' style='text-align: center; cursor: pointer;' @click='info = item; dialog = true') 
                    b Ver Pedido
    v-dialog(v-model='dialog', persistent max-width='1028px')
      v-container(style='background-color:white !important;max-width: 1028px;')
        v-flex(xs12)
          v-card(flat='')
            v-flex(xs12 md12 sm12 style='margin-top:10px')
              v-layout(row, wrap)
                v-flex(xs12 style='display: flex;')
                  div(style='display: flex;align-items: center;')
                    img(src='../assets/logo.png', width='auto' ,height='60')
                v-flex(xs12 style='margin-top: 20px;background: #bfbebe;height: 108px;display: flex;align-items: flex-end;')
                  v-layout(row, wrap style='line-height: 1;')
                    v-flex(xs6)
                      div(style='padding-left: 15px;')
                        p(style='font-weight: 500;') Nro. Pedido: {{info.doc_num}}
                        p(style='font-weight: 500;') Fecha: {{info.fecha | moment('DD-MM-YYYY H:mm A')}}
                        p(style='font-weight: 500;' v-if='info.cliente && info.cliente') Cliente: {{info.cliente}}
                        p(style='font-weight: 500;' v-if='info.pedidos && info.pedidos.co_mone') Moneda: {{info.pedidos.co_mone}}
                    v-flex(xs6 style='display: flex;justify-content: center;align-items: center;')
                      p(style='font-size: 21px !important;font-weight: 600;' v-if='info.pedidos && info.pedidos.status') {{estatusPedi(info.pedidos.status)}}
                v-flex(xs12 style='height: 45px;background: #f3f3f3;display: flex;align-items: center;border-bottom: 1px solid;')
                  v-layout(row, wrap style='line-height: 1;')
                    v-flex(xs4 style='padding-left: 15px;')
                      span(style='font-weight: 500;') Producto
                    v-flex(xs2)
                      span(style='font-weight: 500;display: flex;justify-content: center;') Unidad
                    v-flex(xs2)
                      span(style='font-weight: 500;display: flex;justify-content: center;') Cantidad
                    v-flex(xs4)
                      span(style='font-weight: 500;display: flex;justify-content: center;') Monto
                v-flex(v-for='(item,index) in info.articulos' xs12 v-bind:class="{ 'active': par(index), 'pasive': comparar(index) }" style='height: 45px;background: #f3f3f3;display: flex;align-items: center;')
                  v-layout(row, wrap style='line-height: 1;')
                    v-flex(xs4 style='padding-left: 15px;')
                      span(style='font-weight: 400;font-size: 14px;') {{item.articulo.art_des}}
                    v-flex(xs2)
                      span(style='font-weight: 400;display: flex;justify-content: center;font-size: 14px;') {{item.co_uni}}
                    v-flex(xs2)
                      span(style='font-weight: 400;display: flex;justify-content: center;font-size: 14px;') {{item.total_art}}
                    v-flex(xs4)
                      span(style='font-weight: 400;display: flex;justify-content: center;font-size: 14px;') {{info.pedidos.co_mone}} {{transform(info.pedidos.tasa ? item.reng_neto / info.pedidos.tasa : item.reng_neto)}}
                v-flex(xs12 style='height: 45px;background: #fff;display: flex;align-items: center;')
                v-flex(xs12 style='height: 45px;background: #f3f3f3;display: flex;align-items: center;' v-if='info.pedidos && info.pedidos.monto_imp')
                  v-layout(row, wrap style='line-height: 1;')
                    v-flex(xs6)
                    v-flex(xs3 style='display: flex;justify-content: center;')
                      span(style='font-weight: 500;') SubTotal:
                    v-flex(xs3 style='display: flex;justify-content: center;')
                      span(style='font-weight: 400 !important;font-style: italic;') {{info.pedidos.co_mone}} {{transform(info.pedidos.tasa ? info.pedidos.total_bruto / info.pedidos.tasa : info.pedidos.total_bruto)}}
                v-flex(xs12 style='height: 45px;background: #fff;display: flex;align-items: center;' v-if='info.pedidos && info.pedidos.monto_imp')
                  v-layout(row, wrap style='line-height: 1;')
                    v-flex(xs6)
                    v-flex(xs3 style='display: flex;justify-content: center;')
                      span(style='font-weight: 500;') Iva:
                    v-flex(xs3 style='display: flex;justify-content: center;')
                      span(style='font-weight: 400 !important;font-style: italic;') {{info.pedidos.co_mone}} {{transform(info.pedidos.tasa ? info.pedidos.monto_imp / info.pedidos.tasa : info.pedidos.monto_imp)}}
                v-flex(xs12 style='height: 45px;background: #f3f3f3;display: flex;align-items: center;' v-if='info.pedidos && info.pedidos.total_neto')
                  v-layout(row, wrap style='line-height: 1;')
                    v-flex(xs6)
                    v-flex(xs3 style='display: flex;justify-content: center;')
                      span(style='font-weight: 500;') Total:
                    v-flex(xs3 style='display: flex;justify-content: center;')
                      span(style='font-weight: 400 !important;font-style: italic;') {{info.pedidos.co_mone}} {{transform(info.pedidos.tasa ? info.pedidos.total_neto / info.pedidos.tasa : info.pedidos.total_neto)}}
          v-flex(xs12 sm12 style='margin-top:20px')
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-btn(style="background:black;border-radius:10px;", @click.native='dialog=false') Salir
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon using CDN
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// Configuración de íconos personalizados
const defaultIcon = L.icon({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Configuración para ícono de pedido
const pedidoIcon = L.icon({
  ...defaultIcon.options,
  // Usar el mismo ícono pero con un color diferente usando CSS
  className: 'pedido-marker',
  iconSize: [32, 32],
  iconAnchor: [16, 32]
});

export default {
  name: "mSeguimiento",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data: () => ({
    dialog4: false,
    ruta: serverImg,
    centrarmapa: { lat: 10.0738900, lng: -69.3227800 },
    zooom: 12,
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    selectedMarker: null,
    opcion1: [
      {
        text: "Todos",
        value: "1"
      }
    ],
    opcion2: [
      {
        text: "Solo Vendedores",
        value: "1"
      },
      {
        text: "Pedidos y Vendedores",
        value: "2"
      }
    ],
    filtroVen: "1",
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: '',
    menu1: false,
    filtroPed: "1",
    dialog: false,
    info: {},
    marcadores: [],
    vendedores: [],
    pedidos: []
  }),
  sockets: {
    act() {
      this.actSocket();
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  created() {
    this.initialize();
    this.dateFormatted = this.formatDate(this.date);
  },
  methods: {
    transform(val) {
      val = val.toString().split('.');
      if (val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ',' + val[1].slice(0, 2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    estatusPedi(status) {
      status = status.replace(' ', '');
      switch (status) {
        case '0': return 'Creado';
        case '1': return 'Parcial';
        case '2': return 'Procesado';
        case '3': return 'Sin Enviar';
        default: return status;
      }
    },
    comparar(data) {
      return (data + 1) === this.info.articulos.length;
    },
    par(data) {
      return data % 2 !== 0;
    },
    getIcon(item) {
      // Configuración base del ícono
      const baseIcon = {
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
        className: 'default-marker'
      };

      // Si es un vendedor
      if (item.vend) {
        return L.icon({
          ...baseIcon,
          className: 'vendedor-marker'
        });
      } 
      // Si es un pedido
      else if (item.doc_num) {
        return L.icon({
          ...baseIcon,
          className: 'pedido-marker'
        });
      }
      // Por defecto
      return L.icon(baseIcon);
    },
    openInfoWindowTemplate(item) {
      this.info = item;
      if (this.$refs.map) {
        this.$refs.map.mapObject.setView([item.coordenadas.lat, item.coordenadas.lng], this.zooom);
      }
    },
    async busqueda() {
      this.selectedMarker = null;
      this.dialog4 = true;
      let info = {
        vendedor: this.filtroVen,
        pedido: this.filtroPed,
        fecha: this.date
      };
      
      try {
        const res = await Api.post("ubicacion/seguimiento", info);
        this.marcadores = res.data.map(item => ({
          ...item,
          coordenadas: {
            lat: parseFloat(item.coordenadas.lat),
            lng: parseFloat(item.coordenadas.lng)
          },
          ...(item.vend && item.icono ? {
            icono: item.icono.startsWith('http') ? item.icono : this.ruta + item.icono
          } : {})
        }));
        
        if (this.marcadores.length > 0 && this.$refs.map) {
          const firstMarker = this.marcadores[0];
          this.$nextTick(() => {
            this.$refs.map.mapObject.setView(
              [firstMarker.coordenadas.lat, firstMarker.coordenadas.lng],
              this.zooom
            );
          });
        }
      } catch (err) {
        console.error('Error al cargar el seguimiento:', err);
      } finally {
        this.dialog4 = false;
      }
    },
    async actSocket() {
      let info = {
        vendedor: this.filtroVen,
        pedido: this.filtroPed,
        fecha: this.date
      };
      
      try {
        const res = await Api.post("ubicacion/seguimiento", info);
        const newMarkers = [];
        const existingVendors = new Set();
        const existingOrders = new Set();
        
        // Procesar marcadores existentes
        this.marcadores.forEach(marker => {
          if (marker.vend) {
            existingVendors.add(marker.co_ven);
          } else if (marker.doc_num) {
            existingOrders.add(marker.doc_num);
          }
        });
        
        // Procesar nuevos datos
        for (const item of res.data) {
          const isVendor = !!item.vend;
          const isOrder = !!item.doc_num;
          
          if (isVendor) {
            const existingIdx = this.marcadores.findIndex(m => m.co_ven === item.co_ven && m.vend);
            
            if (existingIdx >= 0) {
              // Actualizar posición existente
              this.$set(this.marcadores[existingIdx], 'coordenadas', {
                lat: parseFloat(item.coordenadas.lat),
                lng: parseFloat(item.coordenadas.lng)
              });
            } else {
              // Agregar nuevo vendedor
              newMarkers.push({
                ...item,
                coordenadas: {
                  lat: parseFloat(item.coordenadas.lat),
                  lng: parseFloat(item.coordenadas.lng)
                },
                icono: item.icono ? (item.icono.startsWith('http') ? item.icono : this.ruta + item.icono) : null
              });
            }
          } else if (isOrder && !existingOrders.has(item.doc_num)) {
            // Agregar nuevo pedido
            newMarkers.push({
              ...item,
              coordenadas: {
                lat: parseFloat(item.coordenadas.lat),
                lng: parseFloat(item.coordenadas.lng)
              },
              icono: require("../assets/iconos/pedido.png")
            });
          }
        }
        
        // Agregar nuevos marcadores
        if (newMarkers.length > 0) {
          this.marcadores = [...this.marcadores, ...newMarkers];
        }
      } catch (error) {
        console.error('Error en actualización de ubicaciones:', error);
      }
    },
    async initialize() {
      this.dialog4 = true;
      this.opcion1 = [{
        text: "Todos",
        value: "1"
      }];
      this.filtroVen = "1";
      let info = {
        vendedor: this.filtroVen,
        pedido: this.filtroPed,
        fecha: this.date
      }
      try {
        const res = await Api.post("ubicacion/seguimiento", info);
        this.marcadores = res.data.map(item => {
          if (item.vend) {
            const newItem = {
              ...item,
              coordenadas: {
                lat: parseFloat(item.coordenadas.lat),
                lng: parseFloat(item.coordenadas.lng)
              },
              icono: item.icono ? (item.icono.startsWith('http') ? item.icono : this.ruta + item.icono) : null
            };
            
            // Agregar a opciones de vendedor si no existe
            if (!this.opcion1.some(opt => opt.value === item.co_ven)) {
              this.opcion1.push({
                text: item.vendedor,
                value: item.co_ven
              });
            }
            
            return newItem;
          } else {
            return {
              ...item,
              coordenadas: {
                lat: parseFloat(item.coordenadas.lat),
                lng: parseFloat(item.coordenadas.lng)
              },
              icono: require("../assets/iconos/pedido.png")
            };
          }
        });
        
        // Centrar en el primer marcador si existe
        if (this.marcadores.length > 0 && this.$refs.map) {
          const firstMarker = this.marcadores[0];
          this.$refs.map.mapObject.setView(
            [firstMarker.coordenadas.lat, firstMarker.coordenadas.lng],
            this.zooom
          );
        }
      } catch (err) {
        console.error('Error al cargar datos iniciales:', err);
      } finally {
        this.dialog4 = false;
      }
    }
  }
};
</script>
<style lang="scss">
// Estilos para los marcadores
.leaflet-marker-icon {
  // Estilo para marcadores de vendedor (rojo)
  &.vendedor-marker {
    filter: hue-rotate(0deg) saturate(3) brightness(0.9);
  }
  
  // Estilo para marcadores de pedido (naranja)
  &.pedido-marker {
    filter: hue-rotate(45deg) saturate(3) brightness(0.9);
  }
  
  // Estilo por defecto (azul)
  &.default-marker {
    // Usa el color azul por defecto
  }
  filter: hue-rotate(45deg) saturate(3) brightness(0.9);
}
/* Estilos para el contenedor del mapa */
.map-container {
  height: 100%;
  width: 100%;
  min-height: 400px;
  position: relative;
  z-index: 1;
}

/* Asegurar que el mapa ocupe todo el espacio */
.leaflet-container {
  height: 100%;
  width: 100%;
  z-index: 1;
}

/* Estilos para el popup personalizado */
.leaflet-popup-content-wrapper {
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.leaflet-popup-content {
  margin: 8px 12px;
  line-height: 1.4;
}

.leaflet-popup-content a {
  color: #1976d2;
  text-decoration: none;
}

.leaflet-popup-content a:hover {
  text-decoration: underline;
}

/* Estilos para los marcadores personalizados */
.custom-marker {
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
}

/* Ajustes para pantallas pequeñas */
@media (max-width: 600px) {
  .map-container {
    height: 400px;
  }
}
</style>